import React, { useEffect, useState } from "react";
import footerlogo from "../../assets/images/icons/BrandLogo.png";
import facebook from "../../assets/images/facebook.svg";
import x from "../../assets/images/x.svg";
import instagram from "../../assets/images/instagram.svg";
import google from "../../assets/images/google.svg";
// linkedin replace with snapchat
// import snapchat from "../../assets/images/snapchat.svg";
import delivery from "../../assets/images/icons/icons8-environment-care-32.png";
import delivery2 from "../../assets/images/icons/icons8-shipping-50.png";
import delivery3 from "../../assets/images/icons/icons8-card-payment-50.png";
import delivery4 from "../../assets/images/icons/icons8-online-support-50.png";
import { Link } from "react-router-dom";
import bellicon from "../../assets/images/bell-icon.png";
import { toast } from "react-toastify";
// import { useDispatch } from "react-redux";
import NotifyModal from "../Login/NotifyModal";
import upiIcon from "../../assets/images/upi.jpg";
import visaIcon from "../../assets/images/visa.jpg";
import mastercardIcon from "../../assets/images/mastercard.jpg";
import amazonPayIcon from "../../assets/images/amazonpay.jpg";
import rupayIcon from "../../assets/images/rupay.png";
import newsIcon from "../../assets/images/icons/subscribe footer.png";
const Footer = () => {
  // const dispatch = useDispatch();
  const [settingList, setSettingList] = useState({
    address: "",
    contact: "",
    email: "",
    websiteLink: "",
    facebookLink: "",
    twitterLink: "",
    instagramLink: "",
    googleLink: "",
    snapchatLink: "",
    whatsappNo: "",
    currencyKey: "",
    maxPrice: "",
    minPrice: "",
  });
  const [email, setEmail] = useState("");
  // const [isSubscribed, setIsSubscribed] = useState(false);
  const [emailError, setEmailError] = useState("");
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const fetchSettingList = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/settings`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = await res.json();
      // console.log("res", res)
      setSettingList(data.responseObject);
    } catch (error) {
      // console.log("error fetch faq", error);
      toast.error("error fetch faq", error);
    }
  };

  useEffect(() => {
    fetchSettingList();
  }, []);

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    if (!value) {
      setEmailError("Email is required");
    } else if (!emailPattern.test(value)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const handleSubscribe = async () => {
    const toastId = "email-subscribe-toast";

    if (!email.trim()) {
      if (!toast.isActive(toastId)) {
        toast.error("Please enter email", { toastId });
      }
      return;
    }

    if (!validateEmail(email)) {
      if (!toast.isActive(toastId)) {
        toast.error("Please enter a valid email address", { toastId });
      }
      return;
    }

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/subscribers/subscribe`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );
      const data = await res.json();

      if (data.success) {
        toast.success("Thank you for subscribing to our newsletter!");
        setEmail("");
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      // console.log("error subscribing to newsletter", error);
      toast.error("Failed to subscribe. Please try again.");
    }
  };

  const validateEmail = (email) => {
    return emailPattern.test(email);
  };

  // Common style object for footer titles
  const footerTitleStyle = {
    color: "#3c3260",
    fontSize: "17px",
    fontWeight: "600",
    marginBottom: "25px",
    position: "relative",
    paddingBottom: "10px",
    whiteSpace: "nowrap",
    letterSpacing: "-0.2px", // Slightly reduce letter spacing to help fit text
  };

  return (
    <>
      <section
        className="delivery-option tp-space"
        style={{
          background: "linear-gradient(135deg, #3c3260 0%, #483a6d 100%)",
          padding: "50px 0",
          boxShadow: "0 -10px 30px rgba(0,0,0,0.1)",
        }}
      >
        <div className="container">
          <div className="row g-4 justify-content-center">
            {[
              {
                icon: delivery,
                title: "Eco-Friendly Packaging",
                text: <>Safe, Eco-Friendly Packaging</>,
                width: "48px",
                height: "48px",
              },
              {
                icon: delivery2,
                title: "Express Delivery",
                text: "Fast & reliable shipping options",
                width: "48px",
                height: "48px",
              },
              {
                icon: delivery3,
                title: "Flexible Payment",
                text: "Pay with Multiple Banks, Credit...",
                width: "48px",
                height: "48px",
              },
              {
                icon: delivery4,
                title: "Online Support",
                text: "24 hours a day, 7 days a week",
                width: "48px",
                height: "48px",
              },
            ].map((item, index) => (
              <div key={index} className="col-lg-3 col-md-6 col-sm-6 col-6">
                <div
                  className="delivery-card h-100 text-white"
                  style={{
                    background: "rgba(255,255,255,0.1)",
                    borderRadius: "15px",
                    padding: "25px 20px",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    backdropFilter: "blur(10px)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    height: "100%",
                    minHeight: "200px",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.background = "rgba(255,255,255,0.15)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.background = "rgba(255,255,255,0.1)";
                  }}
                >
                  <div
                    style={{
                      width: "45px",
                      height: "45px",
                      marginBottom: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={item.icon}
                      alt={item.title}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                        width: item.width,
                        height: item.height,
                      }}
                    />
                  </div>
                  <div
                    className="delivery-content"
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <h5
                      style={{
                        color: "white",
                        fontSize: "18px",
                        marginBottom: "12px",
                        fontWeight: "600",
                      }}
                    >
                      {item.title}
                    </h5>
                    <p
                      style={{
                        color: "rgba(255,255,255,0.8)",
                        fontSize: "14px",
                        marginBottom: 0,
                        lineHeight: "1.4",
                      }}
                    >
                      {item.text}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <footer
        className="theme-footer"
        style={{
          background: "#faf7ff",
          padding: "70px 0 0",
          position: "relative",
        }}
      >
        <div className="container">
          <div className="row g-4 justify-content-between">
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="ftr-abt" style={{ marginBottom: "30px" }}>
                <Link to="/" className="ftr-logo d-block">
                  <img
                    src={footerlogo}
                    alt="footerlogo"
                    style={{ maxWidth: "180px" }}
                  />
                </Link>
                <p
                  style={{
                    color: "#666",
                    lineHeight: "1.8",
                  }}
                >
                  We provide top-quality authentic food with fast, reliable
                  delivery – a brand you can trust with every order!
                </p>

                <div className="media mb-4">
                  {[
                    { icon: facebook, link: settingList.facebookLink },
                    { icon: x, link: settingList.twitterLink },
                    { icon: instagram, link: settingList.instagramLink },
                    { icon: google, link: settingList.googleLink },
                  ].map((social, index) => (
                    <Link
                      key={index}
                      to={social.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        marginRight: "15px",
                        background: "#3c3260",
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        display: "inline-flex",
                        justifyContent: "center",
                        alignItems: "center",
                        transition: "transform 0.3s ease, background 0.3s ease",
                        marginBottom: "15px",
                        position: "relative",
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.transform = "translateY(-3px)";
                        e.currentTarget.style.background = "#483a6d";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.background = "#3c3260";
                      }}
                    >
                      <img
                        src={social.icon}
                        alt="social"
                        style={{
                          width: "18px",
                          height: "18px",
                          objectFit: "contain",
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                      />
                    </Link>
                  ))}
                </div>

                <div className="payment-methods">
                  <p
                    style={{
                      fontSize: "14px",
                      color: "#666",
                      fontWeight: "500",
                    }}
                  >
                    Accepted Payments
                  </p>
                  <div className="d-flex flex-nowrap align-items-center gap-3">
                    {[
                      { src: upiIcon, height: "15px" },
                      { src: visaIcon, height: "40px" },
                      { src: mastercardIcon, height: "20px" },
                      { src: amazonPayIcon, height: "50px" },
                      { src: rupayIcon, height: "15px" },
                    ].map((payment, index) => (
                      <img
                        key={index}
                        src={payment.src}
                        alt="payment"
                        style={{
                          height: payment.height,
                          objectFit: "contain",
                        }}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-2 col-md-6 col-sm-6">
              <h4 className="ftr-title" style={footerTitleStyle}>
                Quick Links
              </h4>
              <ul
                className="ftr-link"
                style={{ listStyle: "none", padding: 0 }}
              >
                {[
                  { text: "Home", path: "/" },
                  { text: "Shop", path: "/shop" },
                  { text: "Categories", path: "/category" },
                  { text: "About us", path: "/aboutus" },
                ].map((link, index) => (
                  <li key={index} style={{ marginBottom: "12px" }}>
                    <Link
                      to={link.path}
                      style={{
                        color: "#666",
                        textDecoration: "none",
                        transition: "color 0.3s ease, transform 0.3s ease",
                        display: "inline-block",
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.color = "#3c3260";
                        e.currentTarget.style.transform = "translateX(5px)";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.color = "#666";
                        e.currentTarget.style.transform = "translateX(0)";
                      }}
                    >
                      {link.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <h4 className="ftr-title" style={footerTitleStyle}>
                Customer Service
              </h4>
              <ul
                className="ftr-link"
                style={{ listStyle: "none", padding: 0 }}
              >
                {[
                  { text: "Help", path: "/contactus" },
                  { text: "FAQs", path: "/faq" },
                  { text: "Privacy Policy", path: "/privacypolicy" },
                  { text: "Cancellation Policy", path: "/cancellationpolicy" },
                  { text: "Terms & Conditions", path: "/termsconditions" },
                ].map((link, index) => (
                  <li key={index} style={{ marginBottom: "12px" }}>
                    <Link
                      to={link.path}
                      style={{
                        color: "#666",
                        textDecoration: "none",
                        transition: "color 0.3s ease, transform 0.3s ease",
                        display: "inline-block",
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.color = "#3c3260";
                        e.currentTarget.style.transform = "translateX(5px)";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.color = "#666";
                        e.currentTarget.style.transform = "translateX(0)";
                      }}
                    >
                      {link.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-12">
              <h4 className="ftr-title" style={footerTitleStyle}>
                Contact Us
              </h4>
              <ul
                className="ftr-add"
                style={{
                  listStyle: "none",
                  padding: 0,
                  marginBottom: "30px",
                }}
              >
                {[
                  { icon: "fa-home", text: settingList.address },
                  {
                    icon: "fa-phone",
                    text: "+91 " + settingList.contact,
                    link: `tel:${settingList.contact}`,
                  },
                  {
                    icon: "fa-envelope",
                    text: settingList.email,
                    link: `mailto:${settingList.email}`,
                  },
                ].map((item, index) => (
                  <li key={index} style={{ marginBottom: "15px" }}>
                    {item.link ? (
                      <Link
                        to={item.link}
                        style={{
                          color: "#666",
                          textDecoration: "none",
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          transition: "color 0.3s ease",
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.color = "#3c3260")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.color = "#666")
                        }
                      >
                        <i
                          className={`fa ${item.icon}`}
                          style={{
                            width: "32px",
                            height: "32px",
                            flexShrink: 0,
                            background: "#3c3260",
                            color: "white",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "14px",
                          }}
                        />
                        <span
                          style={{
                            wordBreak: "break-word",
                            lineHeight: "1.4",
                            flex: 1,
                          }}
                        >
                          {item.text}
                        </span>
                      </Link>
                    ) : (
                      <div
                        style={{
                          color: "#666",
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                        }}
                      >
                        <i
                          className={`fa ${item.icon}`}
                          style={{
                            width: "32px",
                            height: "32px",
                            flexShrink: 0,
                            background: "#3c3260",
                            color: "white",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "14px",
                          }}
                        />
                        <span
                          style={{
                            wordBreak: "break-word",
                            lineHeight: "1.4",
                            flex: 1,
                          }}
                        >
                          {item.text}
                        </span>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="row justify-content-center mt-4">
            <div className="col-lg-6 col-md-8 col-sm-12">
              <div
                className="newsletter-box"
                style={{
                  background: "white",
                  padding: "30px",
                  borderRadius: "15px",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.05)",
                  marginBottom: "50px",
                }}
              >
                <div className="text-center mb-4">
                  <img
                    src={newsIcon}
                    alt="newsletter"
                    style={{
                      width: "50px",
                      height: "50px",
                    }}
                  />
                  <h5
                    style={{
                      color: "#333",
                      fontSize: "20px",
                      fontWeight: "600",
                    }}
                  >
                    Subscribe to our newsletter
                  </h5>
                  <p style={{ color: "#666", marginTop: "10px" }}>
                    Sign Up for Exclusive offers and Latest Arrivals!
                  </p>
                </div>

                <div className="subscribe d-flex gap-3">
                  <input
                    type="email"
                    className={`form-control ${emailError ? "is-invalid" : ""}`}
                    placeholder="Enter your email"
                    value={email}
                    onChange={handleEmailChange}
                    maxLength={50}
                    style={{
                      margin: "8px 0",
                      padding: "12px 20px",
                      borderRadius: "30px",
                      border: "1px solid #ddd",
                    }}
                  />
                  <button
                    className="btn"
                    type="button"
                    onClick={handleSubscribe}
                    style={{
                      background: "#3c3260",
                      color: "white",
                      padding: "12px 30px",
                      borderRadius: "30px",
                      fontWeight: "500",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.background =
                        "linear-gradient(0deg, #3c3260 30%, #db73e4 100%)";
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.background = "#3c3260";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    Subscribe
                  </button>
                </div>
                {emailError && (
                  <div
                    className="text-danger text-center mt-1 mb-2"
                    style={{ fontSize: "14px" }}
                  >
                    {emailError}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div
          className="copyright"
          style={{
            background: "linear-gradient(135deg, #3c3260 0%, #483a6d 100%)",
            padding: "20px 0",
            marginTop: "30px",
          }}
        >
          <div className="container">
            <p
              className="text-center mb-0"
              style={{
                color: "white",
                fontSize: "14px",
                opacity: "0.9",
              }}
            >
              © 2025, Sweetz n' Snackz
            </p>
          </div>
        </div>
      </footer>
      <NotifyModal />
      <div
        className="modal fade cancel-modal"
        id="notify-success"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Notify
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="fa fa-times" />
              </button>
            </div>
            <div className="modal-body">
              <div className="text-center">
                <img src={bellicon} alt="bellicon" />
                <h6 className="fz-20 fw-400 mt-3">
                  We will notify you once the product is available
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
